import { AbsoluteFill, Img, useVideoConfig } from 'remotion';
import { getAnchorStyle } from '@/lib/watermark-anchor-style';
import type { WatermarkConfig } from '@/lib/campaign-watermark-types';

type WatermarkProps = {
  /** Optional campaign override. When undefined, renders the default Autoclipper watermark. */
  config?: WatermarkConfig;
};

const Watermark: React.FC<WatermarkProps> = ({ config }) => {
  const { height } = useVideoConfig();

  if (config) {
    const heightPx = height * (config.sizePercent / 100);
    return (
      <AbsoluteFill style={{ pointerEvents: 'none' }}>
        <Img
          src={config.imageUrl}
          style={{
            position: 'absolute',
            height: heightPx,
            width: 'auto',
            objectFit: 'contain',
            opacity: config.opacityPercent / 100,
            ...getAnchorStyle(config.anchor, config.marginXPercent, config.marginYPercent),
          }}
        />
      </AbsoluteFill>
    );
  }

  // Legacy static watermark. Free-plan previews now draw the animated
  // <AutoclipperWatermark> (see ClipWatermark); this branch only remains for
  // callers that still pass showWatermark without a campaign config.
  const maxHeight = height * 0.09;
  return (
    <AbsoluteFill style={{ pointerEvents: 'none' }}>
      <Img
        src="/images/autoclipper-watermark.png"
        style={{
          position: 'absolute',
          top: '75%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: maxHeight,
          width: 'auto',
          objectFit: 'contain',
          opacity: 0.95,
        }}
      />
    </AbsoluteFill>
  );
};

export default Watermark;
